import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2l0 -10","key":"svg-0"}],["path",{"d":"M7 9h1.5a1.5 1.5 0 0 1 0 3h-.5h.5a1.5 1.5 0 0 1 0 3h-1.5","key":"svg-1"}],["path",{"d":"M14 9v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2l-1 0","key":"svg-2"}]]

const IconBadge3d = createReactComponent('outline', 'badge-3d', 'Badge3d', __iconNode);

export default IconBadge3d;